<template>
  <div class="flex flex-col min-h-screen">
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <main
      class="flex-1 container mx-auto max-w-[1200px] w-full pb-7 pt-1 flex flex-col gap-5 px-4 md:px-6"
    >
      <div class="p-4 lg:p-6 rounded-xl bg-white shadow-lg h-full">
        <!-- Header with Back Button -->
        <div class="flex justify-between items-center mb-4">
          <div class="flex items-center gap-2">
            <h2 class="text-lg font-bold text-gray-800">Task Management</h2>
          </div>
          <div class="flex gap-2">
            <button
              @click="this.isAdding = true"
              class="bg-blues hover:bg-hover text-white font-semibold text-xs px-4 py-1.5 rounded-xl transition-colors duration-200"
            >
              Add
            </button>
          <router-link
            :to="{ name: 'PreviewStudentHome' }"
            class="bg-blues hover:bg-hover text-white rounded-2xl text-xs font-semibold px-3 py-1.5 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            Back
          </router-link>
          </div>
        </div>

        <!-- Search and Filter Bar -->
        <div
          class="bg-gradient-to-r from-[#EDF8FF] to-[#f5fafd] p-4 rounded-xl mb-4"
        >
          <div
            class="flex flex-col md:flex-row items-center justify-between gap-4"
          >
            <div class="flex items-center gap-2">
              <svg
                class="w-5 h-5 text-[#0085DB]"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
              <p class="text-[#0085DB] text-sm md:text-base font-semibold">
                Task List : <span>{{ totalCount || 0 }}</span>
              </p>
            </div>

            <div class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <div class="flex justify-end">
                <div class="relative w-full max-w-80">
                  <div
                    class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    v-model="search_title"
                    @input="getTodo(1)"
                    placeholder="Search..."
                    class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  <button
                    v-if="search_title"
                    @click="clearSearch"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-400 hover:text-gray-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Filter Dropdown -->

              <div>
                <select
                  v-model="selectFieldFilter"
                  @change="handleFieldFilterChange"
                  class="w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled>Select Status</option>
                  <option :value="true">Complete</option>
                  <option :value="false">Incomplete</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Task List -->
        <div v-if="todolist.length > 0" class="mb-10">
          <div class=" ">
            <div v-for="task in todolist" :key="task.id" class="py-2">
              <div
                class="flex items-start gap-4 border-b border-gray-100 p-4 hover:bg-gray-50 transition-colors duration-200 rounded-lg"
              >
                <!-- Status Icon -->
                <div class="flex-shrink-0">
                  <div
                    v-if="task.completed == false"
                    class="w-5 h-5 rounded-full border-2 border-blues flex items-center justify-center bg-white"
                  ></div>
                  <div
                    v-else
                    class="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center shadow-sm"
                  >
                    <svg
                      class="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </div>

                <!-- Task Text -->
                <div class="flex-1 min-w-0">
                  <p
                    class="text-sm break-words"
                    :class="{
                      'text-gray-800 font-semibold': task.completed !== true,
                      'text-gray-500 line-through': task.completed === true,
                    }"
                  >
                    {{ task.text }}
                  </p>
                  <span class="text-xs text-gray-400">
                    {{ formatDate(task.updated_at) }}
                  </span>
                </div>

                <!-- Actions -->
                <div class="flex-shrink-0">
                  <div class="flex flex-col items-end gap-1">
                    <div class="flex gap-2 mt-1">
                      <button
                        v-if="task.completed == false"
                        @click="completeTask(task.id)"
                        class="relative group p-1.5 rounded-lg bg-green-50 hover:bg-green-100 transition-all duration-200"
                      >
                        <svg
                          class="w-4 h-4 text-green-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        <span
                          class="absolute top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
                        >
                          Mark Complete
                        </span>
                      </button>

                      <button
                        @click="openEditPopup(task)"
                        class="relative group p-1.5 rounded-lg bg-blue-50 hover:bg-blue-100 transition-all duration-200"
                      >
                        <svg
                          class="w-4 h-4 text-blue-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                        <span
                          class="absolute top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
                        >
                          Edit
                        </span>
                      </button>

                      <button
                        @click="deleteTask(task.id)"
                        class="relative group p-1.5 rounded-lg bg-red-50 hover:bg-red-100 transition-all duration-200"
                      >
                        <svg
                          class="w-4 h-4 text-red-600"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                        <span
                          class="absolute top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
                        >
                          Delete
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div
            class="flex flex-col sm:flex-row justify-center gap-3 my-4 relative"
          >
            <!-- PAGE SIZE -->
            <div
              class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
            >
              <span class="flex md:hidden">Rows per page:</span>
              <select
                v-model="pageSize"
                @change="onPageSizeChange"
                class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>

            <!-- PAGINATION -->
            <div v-if="totalPages > 1" class="flex justify-center">
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="getTodo"
              />
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div
          v-else
          class="flex flex-col items-center justify-center py-12 text-center"
        >
          <svg
            class="w-16 h-16 text-gray-300 mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            />
          </svg>
          <p class="text-gray-500 text-sm">No tasks found</p>
          <p class="text-gray-400 text-xs mt-1">
            Create a new task to get started
          </p>
        </div>
      </div>
  <transition name="modal">
        <div
          v-if="isAdding"
          class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
          @click.self="isAdding = false"
        >
          <div
            class="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden animate-scaleIn"
          >
            <!-- Modal Header -->
            <div class="bg-gradient-to-r from-[#0085DB] to-[#0069b3] px-6 py-4">
              <div class="flex items-center justify-between">
                <h3 class="text-xl font-bold text-white">Add Task</h3>
                <button
                  @click="isAdding = false"
                  class="text-white hover:text-gray-200 transition-colors"
                >
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Modal Body -->
            <div class="p-6">
              <form @submit.prevent="addTask()" class="flex flex-col gap-5">
                <div>
                  <textarea
                    v-model="newTask"
                    rows="5"
                    required
                    class="w-full border border-gray-300 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#0085DB] focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Enter new task ..."
                  ></textarea>
                </div>

                <div class="flex justify-end gap-3 pt-2">
                  <button
                    type="button"
                    @click="isAdding = false"
                    class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all duration-200"
                  >
                    Cancel
                  </button>
                  <div class="flex justify-end items-center gap-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        disable_submit == true
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-blues hover:bg-hover text-white shadow-sm hover:shadow-md'
                      "
                      class="rounded-lg text-sm px-6 py-2 font-semibold transition-all duration-200"
                    >
                      Add
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </transition>
      <!-- Edit Popup Modal -->
      <transition name="modal">
        <div
          v-if="isEditing"
          class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
          @click.self="isEditing = false"
        >
          <div
            class="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden animate-scaleIn"
          >
            <!-- Modal Header -->
            <div class="bg-gradient-to-r from-[#0085DB] to-[#0069b3] px-6 py-4">
              <div class="flex items-center justify-between">
                <h3 class="text-xl font-bold text-white">Edit Task</h3>
                <button
                  @click="isEditing = false"
                  class="text-white hover:text-gray-200 transition-colors"
                >
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Modal Body -->
            <div class="p-6">
              <form @submit.prevent="updateTask()" class="flex flex-col gap-5">
                <div>
                  <label class="block text-sm font-semibold text-gray-700 mb-2"
                    >Task Description</label
                  >
                  <textarea
                    v-model="editTaskText"
                    rows="5"
                    class="w-full border border-gray-300 rounded-lg p-3 text-sm focus:ring-2 focus:ring-[#0085DB] focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Enter task description..."
                  ></textarea>
                </div>

                <div
                  v-if="editmessages"
                  class="text-green-600 text-sm font-medium bg-green-50 p-3 rounded-lg"
                >
                  {{ editmessages }}
                </div>

                <div class="flex justify-end gap-3 pt-2">
                  <button
                    type="button"
                    @click="isEditing = false"
                    class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-all duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      disable_submit
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-blues hover:bg-hover text-white shadow-sm hover:shadow-md'
                    "
                    class="rounded-lg text-sm px-6 py-2 font-semibold transition-all duration-200"
                  >
                    <span v-if="!disable_submit">Update</span>
                    <span v-else class="flex items-center gap-2">
                      <svg
                        class="animate-spin h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Updating...
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </transition>
    </main>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Student/Header.vue";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  name: "TaskList",
  data() {
    return {
      todolist: [],
      search_title: "",
      loading: true,
      isEditing: false,
      isAdding:false,
      editTaskText: "",
      editTaskId: null,
      showButton: false,
      editmessages: "",
      open_filter_drop: false,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      filterStatus: null,
      disable_submit: false,
      selectFieldFilter: "",
       newTask: "",
      messages: {
        text: "",
        type: "null",
      },
      totalCount:"",
    };
  },

  components: {
    Header,
    Footer,
    Pagination,
    FlashMessage
  },

  computed: {
    ...mapGetters("student", [
      "studentdata"]),
  },
  created() {
    this.getTodo(1);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleFieldFilterChange() {
      if (this.selectFieldFilter !== "") {
        this.filterTasks(this.selectFieldFilter);
      }
    },
    clearSearch() {
      this.search_title = "";
      this.getTodo(1);
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.open_filter_drop = null;
      }
    },
    async getTodo(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.studentdata.studentId}/?completed=${this.filterStatus}&Key=${this.studentdata.studentToken}&page=${page}&page_size=${this.pageSize}&search=${this.search_title}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
            this.totalPages = response.data.total_page;
            this.totalCount = response.data.total;

          }
        });
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getTodo(1);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },

    async filterTasks(isComplete) {
      this.filterStatus = isComplete;
      this.currentPage = 1;
      await axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.studentdata.studentId}/?completed=${isComplete}&Key=${this.studentdata.studentToken}&page=${this.currentPage}&page_size=${this.pageSize}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
            this.totalPages = response.data.total_page;
            this.totalCount = response.data.total;
            this.open_filter_drop = false;
          }
        });
    },
    openEditPopup(task) {
      this.editTaskText = task.text;
      this.editTaskId = task.id;
      this.isEditing = true;
    },
       addTask() {
      this.disable_submit = true;
      if (this.newTask.trim()) {
        let bodyVal = {
          text: this.newTask,
          user: this.studentdata.studentId,
        };

        axios
          .post(
            `${process.env.VUE_APP_API}/to-do-create/?Key=${this.studentdata.studentToken}`,
            bodyVal,
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.messages = {
                text: response.data.message,
                type: "success",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "null",
                };
                this.disable_submit = false;
                this.isAdding = false;
                this.newTask = "";
                this.getTodo(1);
              }, 3000);
            } else {
              this.messages = {
                text: " Event Faild",
                type: "error",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "null",
                };
                this.disable_submit = false;
              }, 3000);
            }
          })
          .finally(() => {
            setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
          });
      }
    },
    updateTask() {
      this.disable_submit = true;

      let formdata = {
        text: this.editTaskText,
      };
      console.log("formdata", formdata);

      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-text-edit/${this.editTaskId}/?Key=${this.studentdata.studentToken}`,
          formdata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.editmessages = response.data.message;

            setTimeout(() => {
              this.editmessages = "";
              this.isEditing = false;
              this.disable_submit = false;
              this.getTodo(this.currentPage);
            }, 2000);
          }
        })
        .finally(() => {
          this.loaders = false;
          this.disable_submit = false;
        });
    },
    deleteTask(id) {
      console.log("sdafsdfsdfsd", id);
      axios
        .delete(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.studentdata.studentToken}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.getTodo(this.currentPage);
          }
        });
    },
    completeTask(id) {
      let completedata = {
        completed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.studentdata.studentToken}`,
          completedata,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.getTodo(this.currentPage);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 400px) !important;
}
</style>
